import React, {useState} from "react";
import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";


import AuthService from "../login/AuthService";
import ScaleConfigPage from "./ScaleConfigPage";
import ScaleDashboardPage from "./ScaleDashboardPage";
import ScaleRegisterPage from "./ScaleRegisterPage";
import ScaleModal from "../dashboard/calender/scaleModal";
import DutyModal from "../dashboard/calender/plantaoModal";
import Swal from "sweetalert2";
import {Link} from "react-router-dom";
import ImportModal from "../import/ImportModal";

const Scale = () => {
    document.title = "Escala | Plantão Rápido";
    const user = AuthService.getUserData();
    const [showScaleModal, setShowScaleModal] = useState(false);
    const [showDutyModal, setShowDutyModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [importType, setImportType] = useState(null); // Define se é Escala ou Plantão
    const [newEvent, setNewEvent] = useState(null); // Dados do evento

    const handleNewButtonClick = () => {
        setShowScaleModal(true);

    };

    const handleImportButtonClick = () => {
        setImportType(3); // Define tipo 1 para Escala
        setShowImportModal(true);
    };

    const handleScaleModalClose = () => {
        setShowScaleModal(false);
    };

    const handleDutyModalClose = () => {
        setShowDutyModal(false);
    };

    const handleImportModalClose = () => {
        setShowImportModal(false);
        setImportType(null);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Escala Padrão" pageTitle="Plantão"/>
                    <Row>
                        <div className="row">
                            <div className="col-sm-4 mt-4 align-items-lg-end">
                                <button type="button"
                                    className="btn btn-outline-dark m-1"
                                    onClick={() =>handleImportButtonClick()}
                                >
                                    <i className="fa fa-upload"></i> Importar
                                </button>
                                <button type="button"
                                    className="btn btn-outline-primary"
                                    onClick={() =>handleNewButtonClick()}
                                >
                                    <i className="fa fa-plus"></i> Novo Cadastro
                                </button>
                            </div>

                        </div>


                        <div className="row">
                            <div className="profile-menu">
                                <ul className="nav nav-tabs nav-tabs-solid">

                                    <li className="nav-item">
                                        <a
                                            className="nav-link active"
                                            data-bs-toggle="tab"
                                            href="#tab-dashboard"
                                        >
                                            Dashboard
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link `}
                                            data-bs-toggle="tab"
                                            href="#tab-config"
                                        >
                                            Configurar Escala
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className="nav-link"
                                            data-bs-toggle="tab"
                                            href="#tab-report"
                                        >
                                            Grade
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="tab-content profile-tab-cont">
                                {/* Dashboard */}
                                <div className="tab-pane fade show active" id="tab-dashboard">
                                    <ScaleDashboardPage/>
                                </div>

                                {/* Calendário */}
                                <div className={`tab-pane fade  ${user?.users_type_id === 1 ? "show active" : ""}`}
                                     id="tab-calendar">
                                    <ScaleConfigPage/>
                                </div>

                                {/* Relatório */}
                                <div className="tab-pane fade" id="tab-report">
                                    <ScaleRegisterPage/>
                                </div>
                            </div>
                        </div>


                        {/* Modal de Escala */}
                        {showScaleModal && (
                            <ScaleModal
                                show={showScaleModal}
                                handleClose={handleScaleModalClose}
                                handleSubmit={() => {
                                    setShowScaleModal(false);
                                }}
                            />
                        )}

                        {/* Modal de Plantão */}
                        {showDutyModal && (
                            <DutyModal
                                show={showDutyModal}
                                handleClose={handleDutyModalClose}
                                handleSubmit={() => {
                                    setShowDutyModal(false);
                                }}
                            />
                        )}

                        {/* Modal de Importação */}
                        {showImportModal && (
                            <ImportModal
                                show={showImportModal}
                                onHide={handleImportModalClose}
                                importType={importType} // Passa o tipo de importação
                            />
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Scale;
